export default __webpack_public_path__ + "img/fleetview.9e9ad9c1.jpg";